 <template>
  <div class="info-region-container">
    <div class="all-content-container" style="margin:0 auto;width:100%">
      <div class="container1">
        <div class="titlemaun">
          <h4>审批记录</h4>
 
        </div>
        <el-form :inline="true" :model="dialogformInline" class="demo-form-inline" >
          <el-form-item label="审批场景：" prop="scene">
            <el-select v-model="dialogformInline.scene" placeholder="请选择审批场景">
              <el-option
                v-for="item in sceneListData"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审批模板："   prop="template">
            <el-select v-model="dialogformInline.template" placeholder="请选择审批模板">
              <el-option
                v-for="item in templateList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审批人：" prop="user">
            <el-input v-model="formInline.user" placeholder="请输入审批人" maxlength="20"  clearable></el-input>
          </el-form-item>

          <el-form-item label="审批时间：">
            <el-date-picker
              style="margin-top:4px"
              v-model="formInline.stasticTime"
              type="daterange"
              align="right"
              unlink-panels
              @change="chane_val"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
             value-format="yyyy-MM-dd"
             clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="onSubmit">查询</el-button>
            <el-button type="button" ass="button" @click="resetonSubmit">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_count">
          <el-table
            :data="tableData"
            align="center"
            boder
            class="data-table"
            style="width: 100%;"
            v-loading="loading"
             :header-cell-style="{background:'#F4F5F7'}"
          >
            <el-table-column
            
              prop="approveScene"
              align="center"
              show-overflow-tooltip
              label="审批场景"
              width="300"
            >
            <template slot-scope="scope">
              <span v-if="scope.row.approveScene==0">生长模型</span>
              <span v-if="scope.row.approveScene==1">决策模型</span>
            </template>
            </el-table-column>
            <el-table-column prop="title" align="center" label="审批模板" width="*"></el-table-column>
            <el-table-column prop="approveUserName" align="center" label="审批人" width="*"></el-table-column>
            <el-table-column prop="approveOpinion" align="center" label="审批意见" width="*"></el-table-column>
            <el-table-column prop="updateTime" align="center" label="审批时间" width="*" ></el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            
            <el-pagination
              background
              layout="prev, pager, next,jumper"
              class="pageTap"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pagesize"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 <script>
 export default {
     name:'approvalRecord',
     data() {
       return {
           endTime:'9999-10-1',
           startTime:'1949-10-1',
           sceneListData:[
              {
              label:'全部',
               id:'',
            },
            {
              label:'生长模型',
               id:0,
            },
            {
              label:'决策模型',
               id:1
            },
           ],
          pagesize:10,
           currentPage:1,
           total:0,
           loading:false,//加载
         formInline: {//查询条件（参数）（0，1）
          scene: '',
          template: '',
          user:'',
          stasticTime:''
        },
        dialogformInline:{
          scene:'',
          template:''
        }
        ,
 
        
      
         
       
          tableData: [],
        noneList:[{}],
        approveResult:'',
         templateList:[]
    };
   },
 
  computed: {},
  created() {
     this.init()
  },
  mounted() {
   
  },
  methods:{
    chane_val(val){
           if(val !=null){
             this.endTime=val[1]
             this.startTime=val[0]
           }
    },
    //时间
    getDateTime(value){
      console.log(value)

    },
    // 重置
    resetonSubmit(){
        this.endTime='9999-10-1'
        this.startTime='1949-10-1'
        this.formInline.stasticTime=''
        this.dialogformInline.scene=''
        this.formInline.user=''
        this.dialogformInline.scene=''
        this.dialogformInline.template=''
        this.getMessageList()

    },
      init(){
          this.getMessageList()//列表信息
          this.getAllApproveTemplate()
      },
 handleCurrentChange(currentPage){//下一页
      this.currentPage=currentPage;
      this.getMessageList()//查询列表
      },
      // 查询
onSubmit(){
  // if(this.formInline.length!=0){
  //   if(this.formInline.stasticTime==null||this.formInline.stasticTime==''||this.formInline.stasticTime==undefined||this.formInline.stasticTime==0) {
  //     this.endTime='9999-10-1'
  //     this.startTime='1949-10-1'
  //   }
  //       this.endTime=this.formInline.stasticTime[0]
  //        this.startTime=this.formInline.stasticTime[1]
       
  // } 
        
      //  if(this.formInline.stasticTime.length!=0){
      //    this.endTime=this.formInline.stasticTime[0]
      //    this.startTime=this.formInline.stasticTime[1]
       
        
      // }else{
      //    this.endTime='9999-10-1'
      //    this.startTime='1949-10-1'
      // }
       this.getMessageList()//查询列表
       },
      
getMessageList(){
  if(this.endTime==undefined ||this.endTime==''){
     this.endTime='9999-10-1'
  }
   if(this.startTime==undefined){
     this.startTime='1495-10-1'
  }
          this.$api.system
          .getgetDataHisApproveList(
              this.currentPage,
              this.pagesize,
               this.approveResult,//审批结果（0失败，1成功）
              this.dialogformInline.scene,//场景
              this.dialogformInline.template,// 模板
              this.formInline.user,// 角色
              this.endTime,
              this.startTime,
         )
          .then((res)=>{
              if(res.code==200){
                console.log(res)
                this.total=res.count
                  this.tableData=res.data;
              }else{
                  this.$message.error(res.msg)
              }
          })
          .catch((err)=>{
              this.$message.error(err)
          })

      },
      // 查询全部审批模板
getAllApproveTemplate(){
  this.$api.system
    .getAllApproveTemplate(
    )
    .then((res)=>{
      if (res.code==200) {
        console.log('888888')
        console.log(res)
        this.templateList=res.data
       }else{
        this.$message.error(res.msg)
       }
    })

},


  }
};
 </script>
  <style >
@import "../../style/approvalTemplate.scss";
.ft_page {
  float: right;
  transform: translate(-650px, 5px);
}

</style>